import { useCreatePartyWithRelation } from "Hooks/useCreatePartyWithRelation";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import type { RelationType } from "Infrastructure/Api/Api";

type Props = {
  onSuccess?: (partyPublicID: string) => void;
  onError?: () => void;
  relationType: RelationType;
};

export const useCreatePartyWithCurrentUserRelation = ({
  onSuccess,
  onError,
  relationType,
}: Props) => {
  const user = useLoggedInUser();
  const { postPartyWithRelation, isPending } = useCreatePartyWithRelation({
    owningPartyID: user?.partyPublicID || "",
    relationType,
    onSuccess,
    onError,
  });

  return {
    postPartyWithCurrentUserRelation: postPartyWithRelation,
    isPending,
  };
};
